// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, update, createOrUpdate, get } from "./operations.js";
export {
  QuotaListOptionalParams,
  QuotaUpdateOptionalParams,
  QuotaCreateOrUpdateOptionalParams,
  QuotaGetOptionalParams,
} from "./options.js";
